import { Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { UploadFile, RcFile } from 'antd/es/upload/interface';
import { useFilePreview } from './util';

const { Dragger } = Upload;

type DragAndDropProps = {
  readonly id: string;
  readonly addFile: (file: RcFile | readonly RcFile[]) => void;
  readonly removeFile: (file: UploadFile) => void;
};

const DragAndDrop = ({ id, addFile, removeFile }: DragAndDropProps) => {
  const { handlePreview, previewContent } = useFilePreview();

  const beforeUploadHandler = (files: RcFile | readonly RcFile[]) => {
    addFile(files);
    return false;
  };

  return (
    <>
      <Dragger
        id={id}
        multiple={false}
        onRemove={removeFile}
        showUploadList={true}
        listType="picture"
        beforeUpload={beforeUploadHandler}
        // Since the file reader is async, we have to use promise here.
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onPreview={handlePreview}
        accept="image/*"
        style={{ marginTop: 10 }}
      >
        <p className="ant-upload-drag-icon">
          <PlusOutlined />
        </p>
        <p className="ant-upload-text">
          Click this area or drag images to upload
        </p>
      </Dragger>
      {previewContent}
    </>
  );
};

export default DragAndDrop;
